import { Routes } from '@angular/router';
import { LoggedInGuard } from './shared/logged-in.guard';
import { PermissionGuard } from './shared/permission.guard';
import { Modules, Permissions } from 'src/utilities/interfaces/permissions.api.interface';

export const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage)
  },
  {
    path: 'centers',
    loadComponent: () => import('./pages/centers/centers.page').then( m => m.CentersPage),
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then( m => m.ProfilePage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'change-password/:idUser',
    loadComponent: () => import('./pages/change-password/change-password.page').then( m => m.ChangePasswordPage),
    canActivate: [],
  },

  // ── Recepción MP ──
  {
    path: 'process',
    loadComponent: () => import('./pages/process/process.page').then( m => m.ProcessPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.Reception },
  },

  // ── Consultas (visible para todos los logueados) ──
  {
    path: 'queries',
    loadComponent: () => import('./pages/queries/queries.page').then( m => m.QueriesPage),
    canActivate: [LoggedInGuard],
  },

  // ── Inventario (visible para todos los logueados) ──
  {
    path: 'inventory',
    loadComponent: () => import('./pages/inventory/inventory.page').then( m => m.InventoryPage),
    canActivate: [LoggedInGuard],
  },

  // ── Producción (submenú) ──
  {
    path: 'productions',
    loadComponent: () => import('./pages/productions/productions.page').then( m => m.ProductionsPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionProduction },
  },

  // ── Nuevo envase → ProductionBatchesPackagings / Add ──
  {
    path: 'add-packaging',
    loadComponent: () => import('./pages/productions/add-packaging/add-packaging.page').then( m => m.AddPackagingPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatchesPackagings, permission: Permissions.Add },
  },

  // ── Nuevo lote → ProductionBatches / Add ──
  {
    path: 'add-batch',
    loadComponent: () => import('./pages/productions/add-batch/add-batch.page').then( m => m.AddBatchPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatches, permission: Permissions.Add },
  },

  // ── Entrada MP/PI → ProductionBatches / Add ──
  {
    path: 'entries',
    loadComponent: () => import('./pages/productions/entries/entries.page').then( m => m.EntriesPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatches, permission: Permissions.Add },
  },

  // ── Consultas producción → ProductionProduction / List ──
  {
    path: 'production-queries',
    loadComponent: () => import('./pages/productions/production-queries/production-queries.page').then( m => m.ProductionQueriesPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionProduction, permission: Permissions.List },
  },

  // ── Detalle consultas producción (entradas) → ProductionProduction / List ──
  {
    path: 'production-queries-entries/:id',
    loadComponent: () => import('./pages/productions/production-queries/production-queries-entries/production-queries-entries.page').then( m => m.ProductionQueriesEntriesPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionProduction, permission: Permissions.List },
  },

  // ── Detalle consultas producción (salidas) → ProductionProduction / List ──
  {
    path: 'production-queries-exits/:id',
    loadComponent: () => import('./pages/productions/production-queries/production-queries-exits/production-queries-exits.page').then( m => m.ProductionQueriesExitsPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionProduction, permission: Permissions.List },
  },

  // ── Finalizar lote → ProductionBatches / Edit ──
  {
    path: 'finish-batch',
    loadComponent: () => import('./pages/productions/finish-batch/finish-batch.page').then( m => m.FinishBatchPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatches, permission: Permissions.Edit },
  },

  // ── Turnos (público) ──
  {
    path: 'shifts/:idLocation',
    loadComponent: () => import('./pages/shifts/shifts.page').then( m => m.ShiftsPage),
    canActivate: [],
  },

  // ── Cargas → Loads ──
  {
    path: 'loads',
    loadComponent: () => import('./pages/loads/loads.page').then( m => m.LoadsPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.Loads },
  },

  // ── Anular envase → ProductionBatchesPackagings / CancelPackaging ──
  {
    path: 'cancel-packaging',
    loadComponent: () => import('./pages/productions/cancel-packaging/cancel-packaging.page').then( m => m.CancelPackagingPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatchesPackagings, permission: Permissions.CancelPackaging },
  },

  // ── Gestión envases (submenú) → ProductionBatchesPackagings / CancelPackaging ──
  {
    path: 'packaging-management',
    loadComponent: () => import('./pages/productions/packaging-management/packaging-management.page').then( m => m.PackagingManagementPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.ProductionBatchesPackagings, permission: Permissions.CancelPackaging },
  },

  // ── Reetiquetar (visible para todos los logueados) ──
  {
    path: 'relabel-batch',
    loadComponent: () => import('./pages/relabel-batch/relabel-batch.component').then( m => m.RelabelBatchComponent),
    canActivate: [LoggedInGuard],
  },

  // ── Solicitar baja inventario → Inventory / RequestInventoryDeletion ──
  {
    path: 'inventory-deletion',
    loadComponent: () => import('./pages/productions/packaging-management/inventory-deletion/inventory-deletion.page').then( m => m.InventoryDeletionPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.Inventory, permission: Permissions.RequestInventoryDeletion },
  },

  // ── Solicitar alta inventario → Inventory / RequestInventoryAddition ──
  {
    path: 'inventory-addition',
    loadComponent: () => import('./pages/productions/packaging-management/inventory-addition/inventory-addition.page').then( m => m.InventoryAdditionPage),
    canActivate: [LoggedInGuard, PermissionGuard],
    data: { module: Modules.Inventory, permission: Permissions.RequestInventoryAddition },
  },
];
